import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-adobe-redirect',
  templateUrl: './adobe-redirect.component.html',
  styleUrls: ['./adobe-redirect.component.css']
})
export class AdobeRedirectComponent implements OnInit {

	showError:boolean = false;

  constructor(private route: ActivatedRoute) { }


    ngOnInit()
    {
    	this.getURlParams();
    }

    getURlParams()
    {
    	 this.route.queryParams.subscribe((params: Params) => {
          if(params['redirect'])
          {
          	var redirectURL = params['redirect'];
          	var sessionCookie = this.getCookie('BREEZESESSION');

          	if(sessionCookie !=''  && sessionCookie != null)
          	{
          		window.location.href = redirectURL+'?session='+sessionCookie;
          	}
          	else
          	{
          		this.showError = true;
          	}
          }
          else
          {
          	this.showError = true;
          }
       });
    }

    getCookie(cname)
    {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
    }

}
